<template>
  <el-dialog
    ref="merchant"
    title="供应商列表信息"
    :visible.sync="visible"
    width="68%"
    :append-to-body="true"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form :model="query" :inline="true" size="small" @submit.native.prevent>
      <el-form-item>
        <el-input v-model="query.searchKey" placeholder="请输入供应商名称" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="merchanTable"
      :load="loading"
      :data="data"
      border
      max-height="280px"
      size="small"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      :row-key="(row) => row.id"
    >
      <el-table-column type="selection" align="center" width="55" reserve-selection />
      <el-table-column label="供应商ID" width="120" align="center" prop="id" />
      <el-table-column label="供应商" prop="name" align="center" />
    </el-table>
    <pagination
      v-if="page.total > 0"
      :total="page.total"
      :page.sync="page.current"
      :limit.sync="page.size"
      @pagination="onLoad"
    />
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getMerchantListPage, getLineByMerchant } from '@/api/marketing/coupon-api'
  export default {
    name: 'selectMerchant',
    data() {
      return {
        visible: false,
        loading: true,
        data: [],
        query: {},
        selections: [],
        // seelctType: '',
        page: {
          current: 1,
          size: 10,
          total: 0
        },
        selectData: []
      }
    },
    methods: {
      init() {
        this.visible = true
        this.$nextTick(() => {
          this.onLoad()
        })
      },
      search() {
        this.onLoad()
      },
      async onLoad() {
        this.loading = true
        const adonData = {
          current: this.page.current,
          size: this.page.size,
          ...this.query
        }
        await getMerchantListPage(adonData).then((resp) => {
          this.loading = false
          this.data = resp.data.records.filter((p) => p.id !== '0')
          this.page.total = resp.data.total
        })
      },
      submit() {
        this.$loading()
        setTimeout(() => {
          this.$emit('submit', this.selectData)
          this.$loading().close()
          this.handleClose()
        }, 800)
      },
      handleSelectionChange(val) {
        if (val) {
          this.selectData = val.map((item) => {
            return {
              merchantName: item.name,
              merchantId: item.id,
              line: []
            }
          })
          this.selectData.forEach((item) => {
            getLineByMerchant(item.merchantId).then((resp) => {
              const { code, data } = resp || {}
              if (code !== 0 || !Array.isArray(data)) {
                return
              }
              item.line = data
            })
          })
        }
      },
      handleClose(done) {
        this.visible = false
        done && done()
      }
    }
  }
</script>

<style scoped></style>
